import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { ProfileRoutingModule } from './profile-routing.module';

import { ProfileComponent } from './profile.component';
import { UserProfileComponent } from './userProfile.component';
import { MacAddressesComponent } from './macAddresses.component';
import { TravelDefaultsComponent } from './travel-defaults/travel-defaults.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';


@NgModule({
  imports: [
    SharedModule,
    ProfileRoutingModule
  ],
  declarations: [
    ProfileComponent,
    UserProfileComponent,
	MacAddressesComponent,
	TravelDefaultsComponent,
	PasswordResetComponent
  ]
})
export class ProfileModule { }
